// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"183":"a0d767b7","723":"da07aacc","820":"16e0fd92","978":"60ad0be7"}[chunkId] + ".css";
};